import { jsx as _jsx } from "react/jsx-runtime";
import { Select } from '@guildeducationinc/recess';
import { useClients } from '@src/hooks/useClients';
import { useLocale } from 'pe-core-frontend';
import { useMemo } from 'react';
import styles from './ClientsPicker.module.scss';
/**
 * ClientsPicker component allows users to select multiple clients from a list.
 *
 * @param {ClientsPickerProps} props - The properties for the ClientsPicker component.
 * @param {number[]} props.clientIds - The IDs of the selected clients.
 * @param {(clientIds: number[]) => void} props.onChange - Callback function to handle changes in the selected clients.
 *
 * @returns {JSX.Element} The ClientsPicker component.
 *
 * @example
 * <ClientsPicker clientIds={[1, 2, 3]} onChange={(ids) => console.log(ids)} />
 */
export const ClientsPicker = ({ clientIds, onChange }) => {
    const { clients, error } = useClients({ initialPageSize: 100 });
    const { t } = useLocale();
    const options = useMemo(() => {
        return clients.map(client => ({ value: client.id, label: client.name }));
    }, [clients]);
    const handleChange = (e) => {
        const values = e.selection;
        if (values) {
            onChange(values.map(v => parseInt(v.value.toString())));
        }
        else {
            onChange([]);
        }
    };
    return (_jsx(Select, { multiple: true, easyPortal: true, className: styles.clientPicker, label: t('Employer'), options: options, value: clientIds, onChange: handleChange, errors: error?.message }));
};
